import { alpha, makeStyles } from '@material-ui/core/styles';

export const useReportCardActionsStyles = makeStyles((theme) => ({
  menuButton: {
    padding: theme.spacing(1),
    transition: theme.transitions.create(['background-color', 'transform', 'box-shadow'], {
      duration: theme.transitions.duration.short,
    }),
    '&:hover': {
      backgroundColor: alpha(theme.palette.action.hover, 0.08),
      transform: 'scale(1.05)',
      boxShadow: theme.shadows[2],
    },
    '&:focus': {
      backgroundColor: alpha(theme.palette.action.focus, 0.12),
      boxShadow: theme.shadows[4],
    },
    '&:active': {
      transform: 'scale(0.98)',
    },
  },
  menu: {
    '& .MuiPaper-root': {
      borderRadius: theme.spacing(1),
      minWidth: 220,
      boxShadow: theme.shadows[8],
      border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
    },
  },
  menuItem: {
    padding: theme.spacing(1.5, 2),
    minHeight: 48,
    transition: theme.transitions.create(['background-color', 'transform'], {
      duration: theme.transitions.duration.shorter,
    }),
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      transform: 'translateX(2px)',
    },
  },
  submenuTrigger: {
    padding: theme.spacing(1.5, 2),
    minHeight: 48,
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.12),
      '& $submenuChevron': {
        transform: 'translateX(2px)',
      },
    },
  },
  submenuChevron: {
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shorter,
    }),
    color: theme.palette.text.secondary,
  },
  menuItemIcon: {
    minWidth: 40,
    marginRight: theme.spacing(1),
  },
  menuHeader: {
    padding: theme.spacing(1.5, 2, 1, 2),
    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
    '& .MuiTypography-caption': {
      fontWeight: 600,
      fontSize: '0.75rem',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      color: theme.palette.text.primary,
    },
  },
  loadingSpinner: {
    color: theme.palette.primary.main,
  },
  // The submenu's invisible backdrop would cover its trigger and fire the trigger's mouse-leave, closing it
  // as it opens; only the paper takes the pointer. Outside clicks reach the parent menu, which closes both.
  contactSubmenu: {
    pointerEvents: 'none',
    '& .MuiPaper-root': {
      pointerEvents: 'auto',
      borderRadius: theme.spacing(0.75),
      minWidth: 200,
      marginLeft: theme.spacing(-1),
      marginTop: theme.spacing(-0.5),
      boxShadow: theme.shadows[12],
      border: `1px solid ${alpha(theme.palette.divider, 0.15)}`,
    },
  },
}));
